import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerResultMarkupGet = {
    path: "/scanner/result/markup/:id",
    method: RouteHttpVerb.GET
};
export { locationRestScannerResultMarkupGet };
